import { selectProvider, selectTag } from "@shared/actions/games";
import { useGames } from "@shared/hooks/games";
import { useLocale } from "@shared/hooks/language";
import { useIsAuth } from "@shared/hooks/user";
import {
  TBannerActions,
  useBannersItems,
} from "@shared/modules/slider/api/banners";
import cx from "classnames";
import React, { useLayoutEffect, useRef } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Swiper from "swiper";

export const Slider = () => {
  const swiper = useRef<Swiper | null>(null);
  const dispatch = useDispatch();
  const games = useGames();
  const history = useHistory();
  const locale = useLocale();
  const intl = useIntl();
  const isAuth = useIsAuth();
  const banners = useBannersItems();

  const onProviderAction = (value: string) => {
    dispatch(selectProvider(+value));
  };

  const onTagAction = (value: string) => {
    dispatch(selectTag(+value));
  };

  const onUrlAction = (url: string) => {
    window.open(url);
  };

  const onGameAction = (id: string) => {
    if (!isAuth) {
      return history.push({
        pathname: "/",
        state: { showAuthModal: true },
      });
    }

    const stringId = games.find(
      (game: Record<string, unknown>) => game.id === +id
    ).string_id;
    history.push(`/games/${stringId}`);
  };

  const renderActions = (action: TBannerActions) => {
    if (!action) {
      return;
    }

    if (action.type === "url") {
      return (
        <div
          onClick={() => onUrlAction(action.value)}
          className="slide__btn btn btn--secondary"
        >
          {
            intl
              .formatMessage({
                id: "boilerplate.components.GameMessage.Button.OpenGame",
              })
              .split(" ")[0]
          }
        </div>
      );
    }

    if (action.type === "provider") {
      return (
        <div
          onClick={() => onProviderAction(action.value)}
          className="slide__btn btn btn--secondary"
        >
          {intl.formatMessage({
            id: "boilerplate.components.Slider.One.Button",
          })}
        </div>
      );
    }

    if (action.type === "tag") {
      return (
        <div
          onClick={() => onTagAction(action.value)}
          className="slide__btn btn btn--secondary"
        >
          {intl.formatMessage({
            id: "boilerplate.components.Slider.One.Button",
          })}
        </div>
      );
    }

    if (action.type === "game") {
      return (
        <div
          onClick={() => onGameAction(action.value)}
          className="slide__btn btn btn--secondary"
        >
          {intl.formatMessage({
            id: "boilerplate.components.Slider.One.Button",
          })}
        </div>
      );
    }
  };

  useLayoutEffect(() => {
    swiper.current = new Swiper(".swiper-container", {
      autoplay: 4000,
      autoplayDisableOnInteraction: false,
      pagination: ".swiper-pagination",
      paginationClickable: true,
      nextButton: ".swiper-button-next",
      prevButton: ".swiper-button-prev",
      effect: "fade",
    });
  }, []);

  const renderSlides = banners?.map((banner, index: number) => {
    const title =
      banner.titles.find((title) => title.lang === locale)?.value ??
      banner.titles.find((title) => title.lang === "en")?.value ??
      "";

    const subtitle =
      banner.subtitles.find((subtitle) => subtitle.lang === locale)?.value ??
      banner.subtitles.find((subtitle) => subtitle.lang === "en")?.value ??
      "";

    return (
      <div
        className={cx("swiper-slide swiper-slide-main", `slideshow--${index}`)}
        key={index}
      >
        {banner?.backgroundImage.desktop ? (
          <img src={banner.backgroundImage?.desktop} alt={"Slide " + index} />
        ) : (
          <div className="slide-not-image"></div>
        )}

        {
          <div className="slideshow__text">
            {<h1 className="slideshow__title">{title}</h1>}

            <p className="slideshow__content">{subtitle}</p>
            {renderActions(banner.action)}
          </div>
        }
      </div>
    );
  });

  return (
    <div className="top-offers">
      <div className="swiper-container">
        <div className="swiper-wrapper">{renderSlides}</div>

        <div className="swiper-pagination" />

        <div
          className="swiper-button-prev"
          role="button"
          aria-label="previous slide"
        />
        <div
          className="swiper-button-next"
          role="button"
          aria-label="next slide"
        />
      </div>
    </div>
  );
};
